import { useEffect, useRef } from 'react';

interface UseChatInputFocusProps {
  disabled?: boolean;
  forceAutofocus?: boolean;
}

export const useConversationInputFocus = ({ disabled, forceAutofocus }: UseChatInputFocusProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (disabled || inputRef.current?.disabled) {
      return;
    }
    inputRef.current?.focus();
    // Enforce re-rendering when disabled state changes
    // Covering also the DOM status, as this might be set disabled on initial renders
  }, [disabled, inputRef.current?.disabled]);

  useEffect(() => {
    if (forceAutofocus) {
      inputRef.current?.focus();
    }
  });
  return inputRef;
};
